<template>
  <div>
    <header class="bar bar-nav">
      <!--<div class="button button-link button-nav pull-left">-->
        <!--<span class="icon icon-left" @click="goBack"></span>-->
      <!--</div>-->
      <h1 class='title'>订单详情</h1>
    </header>
    <div class="content">

      <div class="list-block media-list" style="margin-top: 10px;margin-bottom: 10px">
        <ul>
        <div class="item-inner" style="padding-left: 1rem">
          <div class="item-title-row">
            <div class="item-title">{{BOrder.expressContactor}}</div>
          </div>
          <div class="item-subtitle">{{BOrder.expressAddress}}</div>
          <div class="item-text">{{BOrder.expressPhone}}</div>
        </div></ul>
      </div>

      <div class="list-block media-list" style="margin:0;" v-if="BOrder.merchandises.length > 0">
        <ul v-for="merchandise in BOrder.merchandises" style="margin: 5px 5% 0 5%; width: 90%">
          <li>
            <a @click="goToDetail(merchandise)" class="item-link item-content">
              <div class="item-inner" style="padding-bottom: 0rem">
                <div class="item-title-row">
                  <div class="item-title"><span v-for="title in merchandise._titleList" style="margin-right: .3rem" v-if="title.valueText !== '-1'"><span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span><span v-else>{{title.valueText}}</span></span></div>
                </div>
                <div class="item-subtitle" style="font-size: xx-small">
                  <label class="label-checkbox checkbox-el " v-for="abstract in merchandise._abstractList">
                    <span style="font-size: xx-small;margin:.3rem .3rem .8rem 0;" v-if="abstract.valueText && abstract.valueText !== '-1'" >  <span v-if="abstract.columnName === 'TVInfo'">{{abstract.valueText.TLNo}}</span><span v-else>{{abstract.valueText}}</span></span>
                  </label>
                </div>
                <div class="item-text"  style="height: 1.5rem">
                  <div style="height: 1.6rem">
                  <div style="float:left;">
                    <span style="font-size: x-small;color: #1482E7" v-if="merchandise.selfOperated === 0">【第三方】</span>
                    <span style="margin-left: .3rem"><button class="button workdays" > <span v-if="merchandise.categoryId === 20">周期{{merchandise.workdays}}工作日起</span>
                    <span v-else>周期{{merchandise.workdays}}工作日</span></button></span></div>
                  <div style="float: right;font-size: .5rem">
                    <span class="sub-span" v-if="merchandise.categoryId === 20 || merchandise.categoryId === 10">定制</span>
                    <span class="sub-span" v-else>现货</span>
                  </div>
                </div>
                </div>
                <div v-if="merchandise.discountPrice && merchandise.discountPrice !=0" class="item-title-row" >
                  <div class="item-title" style="color: #6e727b">折扣</div>
                  <div lass="item-after" style="color: #00469A;font-size: 0.1rem"> ￥<span style="font-size: 1rem">{{merchandise.discountPrice}} </span></div>
                </div>
                <div style="font-size: 1rem">
                  <hr>
                    <div>{{merchandise.merchandiseLabel}}</div>
                  <div style="color: #6e727b;float: left" v-if="merchandise.quantity">合计{{merchandise.quantity}}个产品</div>
                  <div  style="color: #6e727b;float: left" v-else="">合计{{1}}个产品</div>
                  <div  style="color: #00469A;font-size: 0.1rem;float: right"> ￥
                    <span style="font-size: 1rem"  v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.ssoFlag === 1 ">{{merchandise.priceMax}} </span>
                    <span style="font-size: 1rem" v-else-if="merchandise.price && merchandise.price !== 0">{{merchandise.price}} </span>
                    <span style="font-size: 1rem" v-else>{{merchandise.priceMax}} </span>
                  </div>  </div>
              </div>
            </a>
            <!--<a @click="goToDetail(merchandise)" class="item-link item-content">-->

              <!--<div class="item-media"></div>-->
              <!--<div class="item-inner">-->
                <!--<div style="margin-top: 1rem;border-bottom:1px solid #1a1a1a; padding-top: 0.5rem">-->
                  <!--<div style="border: #00469A; padding-bottom: .5rem">-->
                      <!--<span v-if="merchandise._subTitleList && merchandise._subTitleList.length > 0" v-for="subTitle in merchandise._subTitleList">-->
                        <!--<span style="position:relative;color: white;background-color: white; padding: 0.1rem;"></span>-->
                        <!--<span style="font-size: 0.7rem;color: white;background-color: #00469A;padding: 0.1rem;">{{subTitle.valueText}}</span></span>-->

                     <!--<span style="font-size: 0.9rem;color: black;" v-if="merchandise._abstractList && merchandise._abstractList.length>0"-->
                           <!--v-for="abstract in merchandise._abstractList">-->
                        <!--{{abstract.valueText}}</span>-->
                  <!--</div>-->

                    <!--<span style="left:0; bottom:0;font-size: 1.2rem;color: #3F3F3F;padding:0.2rem 0 0.2rem 0;font-weight: bold"-->
                          <!--v-if="merchandise._titleList && merchandise._titleList.length > 0" v-for="title in merchandise._titleList">-->
                       <!--<span v-if="title.valueText !== '-1'">{{title.valueText}}</span>-->
                    <!--</span>-->
                  <!--&lt;!&ndash;<merchdata :merchList="merchList" :description="description"></merchdata>&ndash;&gt;-->
                <!--</div>-->
                <!--<div v-if="merchandise.selfOperated === 0" style=" margin-top: 10px;">-->
                  <!--<span style="font-size: x-small;color: #1482E7">【第三方】</span>-->
                <!--</div>-->
                <!--&lt;!&ndash;<div class="item-title-row">&ndash;&gt;-->
                <!--&lt;!&ndash;<div>{{ merchandise.merchandiseLabel}}</div>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--<div v-if="merchandise.discountPrice && merchandise.discountPrice !=0" class="item-title-row">-->
                  <!--<div class="item-title" style="color: #6e727b">折扣</div>-->
                  <!--<div lass="item-after" style="color: #00469A;font-size: 0.1rem"> ￥<span style="font-size: 1.3rem">{{merchandise.discountPrice}} </span></div>-->
                <!--</div>-->
                <!--<div class="item-title-row">-->
                  <!--<div class="item-title" style="color: #6e727b" v-if="merchandise.quantity">合计{{merchandise.quantity}}个产品</div>-->
                  <!--<div class="item-title" style="color: #6e727b" v-else="">合计{{1}}个产品</div>-->
                  <!--<div lass="item-after" style="color: #00469A;font-size: 0.1rem"> ￥-->
                    <!--<span style="font-size: 1.3rem"  v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.ssoFlag === 1 ">{{merchandise.priceMax}} </span>-->
                    <!--<span style="font-size: 1.3rem" v-else-if="merchandise.price && merchandise.price !== 0">{{merchandise.price}} </span>-->
                    <!--<span style="font-size: 1.3rem" v-else>{{merchandise.priceMax}} </span>-->
                  <!--</div>  </div>-->
              <!--</div>-->

            <!--</a>-->
          </li>
        </ul>
      </div>
      <div class="list-block media-list" style="margin:0;" v-else>
        <div v-for="suborder in BOrder.subOrders ">
          <div v-for="merch in suborder.merchandises" style="margin: 5px 5% 0 5%; width: 90%">
            <ul>
              <li>
                <a @click="goToDetail(merch)" class="item-link item-content">
                  <div class="item-inner" style="padding-bottom: 0rem">
                    <div class="item-title-row">
                      <div class="item-title"><span v-for="title in merch._titleList" style="margin-right: .3rem" v-if="title.valueText !== '-1'"><span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span><span v-else>{{title.valueText}}</span></span></div>
                    </div>
                    <div class="item-subtitle" style="font-size: xx-small">
                      <label class="label-checkbox checkbox-el " v-for="abstract in merch._abstractList">
                        <span style="font-size: xx-small;margin:.3rem .3rem .8rem 0;" v-if="abstract.valueText && abstract.valueText !== '-1'" >  <span v-if="abstract.columnName === 'TVInfo'">{{abstract.valueText.TLNo}}</span><span v-else>{{abstract.valueText}}</span></span>
                      </label>
                    </div>
                    <div class="item-text"  style="height: 1.5rem">
                      <div style="height: 1.6rem">
                        <div style="float:left;">
                          <span style="font-size: x-small;color: #1482E7" v-if="merch.selfOperated === 0">【第三方】</span>
                          <span style="margin-left: .3rem"><button class="button workdays" >周期20个工作日</button></span></div>
                        <div style="float: right;font-size: .5rem">
                          <span class="sub-span" v-if="merch.categoryId === 20 || merch.categoryId === 10">定制</span>
                          <span v-else>
                            <span class="sub-span">现货</span>
                            <span class="sub-span">减券</span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div v-if="merch.discountPrice && merch.discountPrice !=0" class="item-title-row">
                      <div class="item-title" style="color: #6e727b">折扣</div>
                      <div lass="item-after" style="color: #00469A;font-size: 0.1rem"> ￥<span style="font-size: 1rem">{{merch.discountPrice}} </span></div>
                    </div>
                    <div style="font-size: 1rem">
                      <hr>
                      <div style="color: #6e727b;float: left" v-if="merch.quantity">合计{{merch.quantity}}个产品</div>
                      <div  style="color: #6e727b;float: left" v-else="">合计{{1}}个产品</div>
                      <div  style="color: #00469A;font-size: 0.1rem;float: right"> ￥
                        <span style="font-size: 1rem"  v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.ssoFlag === 1 ">{{merch.priceMax}} </span>
                        <span style="font-size: 1rem" v-else-if="merch.price && merch.price !== 0">{{merch.price}} </span>
                        <span style="font-size: 1rem" v-else>{{merch.priceMax}} </span>
                      </div>  </div>
                  </div>
                </a>
                <!--<a @click="goToDetail(merch)" class="item-link item-content">-->

                  <!--<div class="item-media"></div>-->
                  <!--<div class="item-inner">-->
                    <!--<div style="margin-top: 1rem;border-bottom:1px solid #1a1a1a; padding-top: 0.5rem">-->
                      <!--<div style="border: #00469A; padding-bottom: .5rem">-->
                      <!--<span v-if="merch._subTitleList && merch._subTitleList.length > 0" v-for="subTitle in merch._subTitleList">-->
                        <!--<span style="position:relative;color: white;background-color: white; padding: 0.1rem;"></span>-->
                        <!--<span style="font-size: 0.7rem;color: white;background-color: #00469A;padding: 0.1rem;">{{subTitle.valueText}}</span></span>-->

                        <!--<span style="font-size: 0.9rem;color: black;" v-if="merch._abstractList && merch._abstractList.length>0"-->
                              <!--v-for="abstract in merch._abstractList">-->
                        <!--{{abstract.valueText}}</span>-->
                      <!--</div>-->

                      <!--<span style="left:0; bottom:0;font-size: 1.2rem;color: #3F3F3F;padding:0.2rem 0 0.2rem 0;font-weight: bold"-->
                            <!--v-if="merch._titleList && merch._titleList.length > 0" v-for="title in merch._titleList">-->
                       <!--<span v-if="title.valueText !== '-1'">{{title.valueText}}</span>-->
                    <!--</span>-->
                      <!--&lt;!&ndash;<merchdata :merchList="merchList" :description="description"></merchdata>&ndash;&gt;-->
                    <!--</div>-->
                    <!--<div v-if="merch.selfOperated === 0" style=" margin-top: 10px;">-->
                      <!--<span style="font-size: x-small;color: #1482E7">【第三方】</span>-->
                    <!--</div>-->
                    <!--<div class="item-title-row">-->
                    <!--<div>{{ merch.merchandiseLabel}}</div>-->
                    <!--</div>-->
                    <!--<div v-if="merch.discountPrice && merch.discountPrice !=0" class="item-title-row">-->
                      <!--<div class="item-title" style="color: #6e727b">折扣</div>-->
                      <!--<div lass="item-after" style="color: #00469A;font-size: 0.1rem"> ￥<span style="font-size: 1.3rem">{{merch.discountPrice}} </span></div>-->
                    <!--</div>-->
                    <!--<div class="item-title-row">-->
                      <!--<div class="item-title" style="color: #6e727b" v-if="merch.quantity">合计{{merch.quantity}}个产品</div>-->
                      <!--<div class="item-title" style="color: #6e727b" v-else="">合计{{1}}个产品</div>-->
                      <!--<div lass="item-after" style="color: #00469A;font-size: 0.1rem"> ￥-->
                        <!--<span style="font-size: 1.3rem"  v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.ssoFlag === 1 ">{{merch.priceMax}} </span>-->
                        <!--<span style="font-size: 1.3rem" v-else-if="merch && merch.price !== 0">{{merch.price}} </span>-->
                        <!--<span style="font-size: 1.3rem" v-else>{{merch.priceMax}} </span>-->
                      <!--</div>  </div>-->
                  <!--</div>-->

                <!--</a>-->
              </li>
            </ul>
          </div>

        </div>

      </div>

      <div class="list-block media-list" style="margin-top: 15px;margin-bottom: 10px">
        <!--<div class="checkout-title">-->
          <!--<span>订单信息</span>-->
        <!--</div>-->
        <ul>
          <div class="item-content">
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">订单编号</div>
                <div class="item-after">{{BOrder.orderNo}}</div>
              </div>

              <div class="item-title-row">
                <div class="item-title">下单时间</div>
                <div class="item-after">{{BOrder.createOrderDT}}</div>
              </div>

            </div>

          </div>
          <div class="item-content">
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">结算方式</div>
                <div class="item-after">{{BOrder.payTypeName}}</div>
              </div>
            </div>
          </div>
          <div class="item-content" v-if="BOrder.balanceType === balanceTypeResearch">
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">课题组名称</div>
                <div class="item-after">{{BOrder.researchGroupName}}</div>
              </div>
            </div>
          </div>
          <div class="item-content" v-if="BOrder.settlementAccountNo">
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">结算账户编号</div>
                <div class="item-after">{{BOrder.settlementAccountNo}}</div>
              </div>
            </div>
          </div>
          <div class="item-content">
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">发票类型</div>
                <div class="item-after">{{BOrder.invoiceTypeName}}</div>
              </div>
            </div>
          </div>
          <div class="item-content">
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">发票抬头</div>
                <div class="item-after">{{BOrder.invoiceTitle}}</div>
              </div>
            </div>
          </div>
          <div class="item-content">
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">发票内容</div>
                <div class="item-after">{{BOrder.invoiceContent}}</div>
              </div>
            </div>
          </div>
        </ul>
      </div>

      <div class="list-block media-list" style="margin-top: 15px;margin-bottom: 10px">
        <ul>
          <div class="item-content">
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">商品总额</div>
                <div class="item-after">￥{{BOrder.initPrice}}</div>
              </div>
            </div>
          </div>

          <div class="item-content">
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">运费</div>
                <div class="item-after">￥{{BOrder.expressPrice}}</div>
              </div>
            </div>
          </div>
          <div class="item-content" v-if="BOrder.discountPrice&& BOrder.discountPrice!= 0">
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">折扣</div>
                <div class="item-after">-￥{{BOrder.discountPrice}}</div>
              </div>
            </div>
          </div>
          <div class="item-content">
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">实支付</div>
                <div class="item-after">￥{{BOrder.totalPrice}}</div>
              </div>
            </div>
          </div>
          <div class="item-content">
          </div>
        </ul>
      </div>
    </div>

    <footer class="bar bar-tab" >
      <div class="item-media">
        <section class="gotopay" style="float: right;margin-top: 0">
          <span class="gotopay_button_style" v-if="BOrder.status === 11 && merchandises[0].categoryId === 20 && (merchandises[0]._attributes.ReguTech === undefined || merchandises[0]._attributes.ReguTech.value !== '5')"
                 @click="buyAgain1(BOrder)">我要扩增</span>
          <span class="gotopay_button_style" v-else
                @click="addCartList(merchandises)">再次购买</span>
        </section>



        <!--<div v-if="BOrder.isFinished" class="tab-item" style="margin-top: 0;padding-right: 5.5rem">-->
          <!--<section class="gotopay" style="float: right;margin-top: 0;position: relative">-->
            <!--<span class="gotopay_button_style"-->
                  <!--@click="sendEMail">获取报告</span>-->
          <!--</section>-->

        <!--</div>-->

      </div>
    </footer>
  </div>
</template>
<script>
  import $ from 'jquery'
  import {mapState, mapMutations} from 'vuex'
  import merchdata from '../../../../components/MerchandiseList.vue'
  import EMKT from '../../../../emkt'
  export default {
    data () {
      return {
        BOrder: JSON.parse(this.$route.query.BOrder),
        merchandises: [],
        ...mapState([
          'sessionInfo'
        ]),
        balanceTypeResearch: EMKT.BALANCE_TYPE_RESEARCH_GROUP
      }
    },
    created () {
      var self = this
      if (this.BOrder.merchandises.length > 0) {
        this.BOrder.merchandises.forEach(function (merchandise) {
          if (merchandise.merchandiseDetailForClient) {
            merchandise.merchandiseDetailForClient.merchandiseId = merchandise.merchandiseGuid
            self.merchandises.push(merchandise.merchandiseDetailForClient)
          }
        })
      } else if (this.BOrder.subOrders.length > 0) {
        for (var i = 0; i < this.BOrder.subOrders.length; i++) {
          this.BOrder.subOrders[i].merchandises.forEach(function (merchandise) {
            if (merchandise.merchandiseDetailForClient) {
              merchandise.merchandiseDetailForClient.merchandiseId = merchandise.merchandiseGuid
              self.merchandises.push(merchandise.merchandiseDetailForClient)
            }
          })
        }
      }
      console.log(self.BOrder)
      if (this.BOrder.balanceType === this.balanceTypeResearch) {
        this.BOrder.payTypeName = '课题组结算'
      }
    },
    components: {
      merchdata
    },
    methods: {
      ...mapMutations([
        'ADD_CART_LIST'
      ]),
      addCartList (merchandises) {
        var self = this
        merchandises.forEach(function (item, index) {
          if (item.categoryId === 10) {
            let mId = item.merchandiseId
            mId = mId + new Date().getTime()
            item.merchandiseId = mId
            if (self.BOrder.productGuid === '') {
              item.productGuid = self.BOrder.subOrders[index].productGuid
            } else {
              item.productGuid = self.BOrder.productGuid
            }
            if (self.BOrder.workdays) {
              item.workdays = self.BOrder.workdays
            }
          }
          if (item.categoryId === 6) {
            self.$weui.topTips('细胞相关产品已经下架！不可再次购买！', 2000)
            return
          }
          if (item.categoryId === 20) {
            item.productGuid = self.BOrder.productGuid
          }
          item.newMerch = 1
          self.ADD_CART_LIST(item)
        })
        this.$router.push({name: 'cart'})
      },
      buyAgain1 (order) {
        order.merchandises[0].amplification = 1
        order.merchandises[0].merchandiseDetailForClient.amplification = 1
        if (typeof order.merchandises[0].merchandiseDetailForClient._attributes.TVInfo.value === 'string') {
          var obj = {}
          obj.TLNo = order.merchandises[0].merchandiseDetailForClient._attributes.TVInfo.value
          if (order.merchandises[0].merchandiseDetailForClient._attributesList[0].columnName === 'TVInfo') {
            order.merchandises[0].merchandiseDetailForClient._attributesList[0].value = obj
            order.merchandises[0].merchandiseDetailForClient._attributesList[0].valueText = obj
//          order.merchandises[0].merchandiseDetailForClient._attributes.TVInfo.value = obj
//          order.merchandises[0].merchandiseDetailForClient._attributes.TVInfo.valueText = obj
          }
        }
        for (var i in order.merchandises[0].merchandiseDetailForClient._attributesList) {
          if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].value !== '214' && (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'AAVBloodType' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'VirusTiter' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'LVAmount' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_LV_Amount' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_LV_Amount' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_Lentivirus_Required' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_Plasmid_Amount' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_Plasmid_CultureRequired' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'NC_Plasmid_Required' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'PlasmidNumber' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Plasmid_Required' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Plasmid_Amount' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Plasmid_CultureRequired')) {
          } else {
            if ((order.merchandises[0].merchandiseDetailForClient._attributesList[i].groupId === 2 || order.merchandises[0].merchandiseDetailForClient._attributesList[i].groupId === 3) && order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName !== 'GeneInfo') {
              order.merchandises[0].merchandiseDetailForClient._attributesList[i].displayable = 0
            }
            order.merchandises[0].merchandiseDetailForClient._attributesList[i].sorteditAble = false
          }
          if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'ContractType') {
            order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = 3
            order.merchandises[0].merchandiseDetailForClient._attributes.ContractType.value = 3
            order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = 3
          }
          if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Type' || order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Tech') {
            order.merchandises[0].merchandiseDetailForClient._attributes.Type.value = '-1'
            order.merchandises[0].merchandiseDetailForClient._attributes.Tech.value = '-1'
            order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = '-1'
            order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = '-1'
          }
//          if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'PreContract') {
//            order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = order.contractNo
//            order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = order.contractNo
//          }
          if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Source') {
            order.merchandises[0].merchandiseDetailForClient._attributes.Source.value = 3
            order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = 3
            order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = 3
          }
          if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'PlasmidNumber') {
            if (order.merchandises[0].merchandiseDetailForClient._attributes.ToolType.value === '2' || order.merchandises[0].merchandiseDetailForClient._attributes.ToolType.value === 2) {
              order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = order.merchandises[0].merchandiseDetailForClient._attributes.TargetNum.value
              order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = order.merchandises[0].merchandiseDetailForClient._attributes.TargetNum.valueText
            }
          }
          if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'VirusTiter') {
            if (order.merchandises[0].merchandiseDetailForClient._attributes.ProductName.value === 'RNAi综合－腺相关病毒外筛') {
              order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = 3
              order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = 3
            }
          }
//          if (order.merchandises[0].merchandiseDetailForClient._attributesList[i].columnName === 'Tech') {
//            if (order.merchandises[0].merchandiseDetailForClient._attributes.ProductName.value === 'RNAi综合－腺病毒外筛' || order.merchandises[0].merchandiseDetailForClient._attributes.ProductName.value === 'CAS9-KO-腺相关病毒') {
//              order.merchandises[0].merchandiseDetailForClient._attributesList[i].value = '-1'
//              order.merchandises[0].merchandiseDetailForClient._attributesList[i].valueText = '-1'
//            }
//          }
        }
        this.$router.push({name: 'finderMerchandises', query: {categoryId: order.merchandises[0].merchandiseDetailForClient.categoryId}, params: {merchandises: order.merchandises[0].merchandiseDetailForClient}})
      },
      sendEMail () {
        var self = this
        if (this.sessionInfo().customerInfo && this.sessionInfo().customerInfo.email) {
          this.callSendEmailMethod(this.sessionInfo().customerInfo.email)
        } else {
          $.alert('请填写正确的邮箱:<input id = "ema" type="text"></input>', function () {
            if ($('#ema').val()) {
              self.callSendEmailMethod($('#ema').val())
            } else {
              self.sendEMail()
            }
          })
        }
      },
      isEamil (str) {
        let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
        return reg.test(str)
      },
      callSendEmailMethod (email) {
        if (!this.isEamil(email)) {
          this.sendEMail()
          return
        }
        var obj = {'orderId': this.BOrder.id, 'email': email}
//        obj.push({'orderId': this.BOrder.id})
//        obj.push({'email': email})
        this.gcapi('sendOrderExperimentReport', obj).then(response => {
          if (response.body.code === 1) {
            $.toast(response.body.message)
            return
          }
          $.toast('已发送到您的邮箱')
        })
      },
      goBack () {
        this.$router.go(-1)
      },
      goToDetail (product) {
        if (product.merchandiseDetailForClient.categoryId !== 10) {
          if (product.merchandiseDetailForClient.categoryId === 20) {
            this.$router.push({name: 'FinderOrderDeail', params: {merchandises: product, type: 1}})
          } else {
            this.$router.push({name: 'finderMerchandises', query: {id: product.merchandiseGuid}})
          }
          //          this.$router.push({name: 'merchandises', query: { id: product.merchandiseGuid }})
        } else {
          this.$router.push({name: 'custDetail', query: {custom: product._attributesList, workdays: product.workdays}})
        }
      }
    }
  }
</script>
<style scoped>
  .gotopay{
    position: absolute;
    right: 0;
    background-color: #045aa5;
  @include wh(5rem, 100%);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -39px;
    width: 100px;
    height: 54px;}
  .gotopay_button_style{
  @include sc(.7rem, #045aa5);
    font-weight: bold;
    color: #fff
  }

  .item-inner {
    display: block;
  }
  .item-title {
    font-size: 0.6rem;
  }
  item-text {
    margin-top: 0.3rem;
  }
  .sub-span {
    font-size: 0.5rem;
    color: white;
    background-color: #00469A;padding: 0.1rem;border-radius:.25rem;
  }

  .workdays {
    display: inherit;font-size: .5rem;line-height: 0px;height: 0.85rem;border-radius:.45rem;border:1px solid #1D66E1;color:#1D66E1
  }
</style>



// WEBPACK FOOTER //
// OrderDetail.vue?512f7dae